// extracted by mini-css-extract-plugin
export default {"searchForm":"SearchForm_searchForm__J6hSf","buyAccountModal":"SearchForm_buyAccountModal__EtA0p","blue":"SearchForm_blue__FYmKT","bold":"SearchForm_bold__Ap41O"};